import {
  TiptapBase,
  BulletList,
  ListItem,
  OrderedList,
  Bold,
  Italic,
  Underline,
  Strike,
  Link,
  History,
  AutoHideToolbar,
  Placeholder,
} from '@/js/util/tiptap/extensions';
import { LinksHandlers, ListsHandlers, TextFormattingHandlers } from '@/js/util/tiptap/handlers';

const placeholder = '—';

export default class ItemDescriptionConfig {
  get extensions() {
    const ItemDescriptionPlaceholder = Placeholder[0].configure({ placeholder });

    return [
      ...TiptapBase,
      ...BulletList,
      ...ListItem,
      ...OrderedList,
      ...Bold,
      ...Italic,
      ...Underline,
      ...Strike,
      ...Link,
      ...History,
      ...AutoHideToolbar,
      ...[ItemDescriptionPlaceholder],
    ];
  }

  get handlers() {
    return {
      ...LinksHandlers,
      ...ListsHandlers,
      ...TextFormattingHandlers,
    };
  }
}
